import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns-jalali";
import { faIR } from "date-fns-jalali/locale";

export const formatPersianDate = (dbDate) => {
  const date = new Date(dbDate);
  const formattedDate = format(date, "EEEE, d MMMM", { locale: faIR });
  return formattedDate;
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const config = {
  country: process.env.REACT_APP_COUNTRY || "IR",
  isAe: process.env.REACT_APP_COUNTRY === "AE",
};
